/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import React from 'react'
import { RouteComponentProps, Route, Link } from 'react-router-dom'
import { observer, Observer } from 'mobx-react'
import { injectProperty, container } from '../../arc/configuration/ServiceLocator'
import { Spinner, Modal, ModalBody, Form, Row, Col, Input, ModalFooter, Button, Label, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, ModalHeader } from 'reactstrap'
import './RequestHistory.scss'
import { IUserSessionStateManager } from '../../arc/services/UserSessionStateManager/contracts'
import { IRequestHistoryStateManager, ICoverageDiscoveryRequestHistoryGridRow, INpi, IPayer, ITransactionStatus, ICoverageDiscoveryRequestHistoryGridFilterCriteria, ICoverageDiscoveryViewReportGrid, IFilteredResponseDetails, IEligibilityStatus } from '../../services/RequestHistoryStateManager/contracts'
import { IRequestHistoryApiClient } from '../../services/RequestHistoryApiClient/contracts'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone, PaginationTotalStandalone } from 'react-bootstrap-table2-paginator'
import filterFactory from 'react-bootstrap-table2-filter'
import 'react-datepicker/dist/react-datepicker.css'
import { TopPart } from '../TopPart/TopPart'
import DatePicker from 'react-datepicker'
import Moment from 'react-moment'
import overlayFactory from 'react-bootstrap-table2-overlay'

import MaskedInput from 'react-text-mask'
import { SettingsManager } from '../../configuration/SettingsManager'
import { isEmpty } from 'validator'
import fileSaver from 'file-saver'
import moment from 'moment'
import { ValidationMessage, MessageTypes } from '../ValidationMessage/ValidationMessage'
import { TransactionStatus } from '../../configuration/Enums/TransactionStaus'
import { DateRange } from '../../configuration/Enums/DateRangeEnum'
export interface IRequestHistoryProps extends RouteComponentProps<any> {
	batchRunId: string | undefined
	RequestHistoryStateManager: IRequestHistoryStateManager
	usersessionStateManager: IUserSessionStateManager
}

interface IRequestHistoryState {
	IsPageLoading: boolean
	modal: any
	fade: any
	isSearching: boolean
	isDobSearched: boolean
	dateOfBirth: Date | null
	isNpiLoadedForFilter: any
	isPayerLoadedForFilter: any
	isStatusLoadedForFilter: any
	npis: any
	payers: any
	statuses: any
	showOrHideNpisFilter: any
	showOrHideStatusFilter: any
	showOrHideEligibilityStatusFilter: any
	showOrHidePayersFilter: any
	npiClicked: any
	payerClicked: any
	statusClicked: any
	transactionDate: any
	isTransactionDateSearched: any
	allOnPageSelected: boolean
	selectedRunDateRangeId: any
	dropdownOpen: any
	modalForTransaction: any
	fadeForTransaction: any
	modalForExport: any
	fadeForExport: any
	IdsForExport: any
	modalForReportInfo: any
	fadeForReportInfo: any
	OkButtonClicked: any
	imageSrc: any
	modalForFinalMessage: any
	showErrorMessage: boolean
	errorMessage: string
	fadeForFinalMessage: any
	runDateFilterTitle: any
	checkedRunDate: any
	allOnPageSelectedForPayer: any
	allOnPageSelectedForNpi: any
	allOnPageSelectedForStatus: any
	allOnPageSelectedForEligibilityStatus: any
	showReviewedUserAndDate: any
	searchedTransactionDate: any
	showDeleteSuccessMessage: any
	deleteSuccessMessage: any
	isFiltersLoadedFirstTime: any
	filteredResponseDetails: IFilteredResponseDetails | null
	typingTimeout: any
	searchedPayerValue: any
}

type TableChangeState = {
	page: number
	sizePerPage: number
	sortField: string
	sortOrder: string
}

@observer
export class RequestHistory extends React.Component<IRequestHistoryProps, IRequestHistoryState> {
	@injectProperty('IRequestHistoryApiClient')
	public readonly RequestHistoryApiClient!: IRequestHistoryApiClient

	private firstNameSearchTextboxRef: React.RefObject<HTMLInputElement>
	private lastNameSearchTextboxRef: React.RefObject<HTMLInputElement>
	private dobSearchTextboxRef: React.RefObject<HTMLInputElement>
	private ssnSearchTextboxRef: React.RefObject<HTMLInputElement>
	private transactionDateTextboxRef: React.RefObject<HTMLInputElement>

	private setAsyncState = (newState: IRequestHistoryState): Promise<void> => new Promise<void>(resolve => this.setState(newState, resolve))
	private isFirstTimeLoading: boolean
	private isLoading: boolean
	private tableHeight: number
	private spinnerHeight: number
	private searchedPayers: any
	constructor(props: Readonly<IRequestHistoryProps>) {
		super(props)
		this.handleTransactionSelectAll = this.handleTransactionSelectAll.bind(this)
		this.toggleValidationMessageForDelete = this.toggleValidationMessageForDelete.bind(this)
		this.loadSelectedDateById = this.loadSelectedDateById.bind(this)
		this.isFirstTimeLoading = true
		this.isLoading = false
		this.tableHeight = 5
		this.spinnerHeight = 5
		this.state = {
			IsPageLoading: true,
			modal: false,
			fade: false,
			isSearching: false,
			isDobSearched: false,
			dateOfBirth: null,
			isNpiLoadedForFilter: false,
			isPayerLoadedForFilter: false,
			isStatusLoadedForFilter: false,
			npis: [],
			payers: [],
			statuses: [],
			showOrHideNpisFilter: false,
			showOrHideStatusFilter: false,
			showOrHideEligibilityStatusFilter: false,
			showOrHidePayersFilter: false,
			npiClicked: false,
			payerClicked: false,
			statusClicked: true,
			transactionDate: null,
			isTransactionDateSearched: false,
			allOnPageSelected: false,
			selectedRunDateRangeId: 0,
			dropdownOpen: false,
			modalForTransaction: false,
			fadeForTransaction: false,
			modalForExport: false,
			fadeForExport: false,
			IdsForExport: [],
			modalForReportInfo: false,
			fadeForReportInfo: false,
			OkButtonClicked: true,
			modalForFinalMessage: false,
			fadeForFinalMessage: false,
			runDateFilterTitle: '',
			checkedRunDate: false,
			allOnPageSelectedForPayer: false,
			allOnPageSelectedForNpi: false,
			allOnPageSelectedForStatus: false,
			allOnPageSelectedForEligibilityStatus: false,
			imageSrc: ['icon-drop-pending-sm', 'icon-drop-active-sm', 'icon-drop-failed-sm', 'icon-drop-missing-sm', 'icon-drop-processing-sm'],
			showErrorMessage: false,
			errorMessage: '',
			showReviewedUserAndDate: true,
			searchedTransactionDate: null,
			showDeleteSuccessMessage: false,
			deleteSuccessMessage: '',
			isFiltersLoadedFirstTime: false,
			filteredResponseDetails: null,
			typingTimeout: null,
			searchedPayerValue: '',
		}

		this.toggle = this.toggle.bind(this)
		this.firstNameSearchTextboxRef = React.createRef()
		this.lastNameSearchTextboxRef = React.createRef()
		this.dobSearchTextboxRef = React.createRef()
		this.ssnSearchTextboxRef = React.createRef()
		this.transactionDateTextboxRef = React.createRef()
	}

	componentDidMount(): void {
		this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria.page = 1
		this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria.sizePerPage = 10
		this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria.sortField = 'id'
		this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria.sortOrder = 'desc'
		this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria.searchTerm.firstName = ''
		this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria.searchTerm.lastName = ''
		this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria.searchTerm.ssn = ''
		this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria.searchTerm.dob = undefined
		this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria.searchTerm.runDate = undefined
		this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria.searchTerm.transactionStatus = []
		this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria.searchTerm.eligibilityStatus = []
		this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria.searchTerm.payers = []
		this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria.searchTerm.npis = []
		this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria.dateRange = 0
		this.changeStateOfCheckboxesToIntitalForEligibilityStatus()

		this.toggleValidationMessageShow = this.toggleValidationMessageShow.bind(this)
		this.props.RequestHistoryStateManager.loadRunDatesRange()
		this.setIsPageLoadState(false)
		window.scrollTo(0, 0)
	}

	componentDidUpdate(prevProps: IRequestHistoryProps): void {
		if (this.props.match.params.batchRunId !== prevProps.match.params.batchRunId) {
			const id = typeof this.props.match.params.batchRunId !== 'undefined' && this.props.match.params.batchRunId !== null ? parseInt(this.props.match.params.batchRunId) : 0
			this.props.RequestHistoryStateManager.loadCoverageDiscoveryRequestHistoryGridResults(id)
			this.clearAll()
		}
	}

	toggleValidationMessageShow(): void {
		this.setState({
			showErrorMessage: !this.state.showErrorMessage,
			errorMessage: '',
		})
	}

	toggleExportModalPopupOnSelection(): any {
		this.setState({
			modalForExport: !this.state.modalForExport,
		})
	}

	handleSearch(): Promise<void> {
		this.tableHeight = document.getElementsByClassName('dataTable')[0].clientHeight
		if (this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridResults.total === 0) {
			this.isFirstTimeLoading = true
			this.tableHeight = this.tableHeight - 15
		} else {
			this.isFirstTimeLoading = false
		}

		this.spinnerHeight = document.getElementsByClassName('dataTable')[0].clientHeight - 80
		this.props.RequestHistoryStateManager.selectedTransactionIds.clear()

		this.setState({
			allOnPageSelected: false,
			filteredResponseDetails: null,
		})

		//reset the payer list
		this.props.RequestHistoryStateManager.setAvailblePayers(this.searchedPayers)
		this.setState({
			searchedPayerValue: '',
		})

		const searchTerm: ICoverageDiscoveryRequestHistoryGridFilterCriteria = {
			firstName: this.firstNameSearchTextboxRef.current ? this.firstNameSearchTextboxRef.current.value : '',
			lastName: this.lastNameSearchTextboxRef.current ? this.lastNameSearchTextboxRef.current.value : '',
			ssn: this.ssnSearchTextboxRef.current ? this.ssnSearchTextboxRef.current.value : '',
			payers: this.props.RequestHistoryStateManager.availablePayers.filter((x: { isSelected: any }) => x.isSelected),
			npis: this.props.RequestHistoryStateManager.availableNpis.filter((x: { isSelected: any }) => x.isSelected),
			transactionStatus: this.props.RequestHistoryStateManager.availableTransactionStatuses.filter((x: { isSelected: any }) => x.isSelected),
			eligibilityStatus: this.props.RequestHistoryStateManager.availableEligibilityStatuses.filter((x: { isSelected: any }) => x.isSelected),
			dob: undefined,
			runDate: undefined,
		}
		if (this.dobSearchTextboxRef.current && this.dobSearchTextboxRef.current.valueAsDate) {
			const curTime = this.dobSearchTextboxRef.current.valueAsDate
			searchTerm.dob = curTime
		}
		if (this.state.checkedRunDate === true) {
			const curTime = this.state.searchedTransactionDate !== null ? this.state.searchedTransactionDate : new Date()
			searchTerm.runDate = curTime
			this.setState({
				transactionDate: searchTerm.runDate,
				searchedTransactionDate: searchTerm.runDate,
			})

			const dateChange = new Date(curTime)
			let runDateFilterTitle = ''
			const dateRangeId = parseInt(this.state.selectedRunDateRangeId)
			if (dateRangeId === 0) {
				runDateFilterTitle =
					'Run Date' +
					'(' +
					moment(dateChange)
						.format('MM/DD/YYYY')
						.toString()
						.split('T')[0] +
					')'
			} else if (dateRangeId === DateRange.OneDay) {
				runDateFilterTitle =
					'Run Date' +
					'(' +
					moment(new Date(dateChange.setDate(dateChange.getDate() - 1)))
						.format('MM/DD/YYYY')
						.toString()
						.split('T')[0] +
					' through ' +
					moment(new Date(dateChange.setDate(dateChange.getDate() + 2)))
						.format('MM/DD/YYYY')
						.toString()
						.split('T')[0] +
					')'
			} else if (dateRangeId === DateRange.ThreeDays) {
				runDateFilterTitle =
					'Run Date' +
					'(' +
					moment(new Date(dateChange.setDate(dateChange.getDate() - 3)))
						.format('MM/DD/YYYY')
						.toString()
						.split('T')[0] +
					' through ' +
					moment(new Date(dateChange.setDate(dateChange.getDate() + 6)))
						.format('MM/DD/YYYY')
						.toString()
						.split('T')[0] +
					')'
			} else if (dateRangeId === DateRange.OneWeek) {
				runDateFilterTitle =
					'Run Date' +
					'(' +
					moment(new Date(dateChange.setDate(dateChange.getDate() - 7)))
						.format('MM/DD/YYYY')
						.toString()
						.split('T')[0] +
					' through ' +
					moment(new Date(dateChange.setDate(dateChange.getDate() + 14)))
						.format('MM/DD/YYYY')
						.toString()
						.split('T')[0] +
					')'
			} else if (dateRangeId === DateRange.TwoWeeks) {
				runDateFilterTitle =
					'Run Date' +
					'(' +
					moment(new Date(dateChange.setDate(dateChange.getDate() - 14)))
						.format('MM/DD/YYYY')
						.toString()
						.split('T')[0] +
					' through ' +
					moment(new Date(dateChange.setDate(dateChange.getDate() + 28)))
						.format('MM/DD/YYYY')
						.toString()
						.split('T')[0] +
					')'
			} else if (dateRangeId === DateRange.OneMonth) {
				runDateFilterTitle =
					'Run Date' +
					'(' +
					moment(new Date(dateChange.setMonth(dateChange.getMonth() - 1)))
						.format('MM/DD/YYYY')
						.toString()
						.split('T')[0] +
					' through ' +
					moment(new Date(dateChange.setMonth(dateChange.getMonth() + 2)))
						.format('MM/DD/YYYY')
						.toString()
						.split('T')[0] +
					')'
			} else if (dateRangeId === DateRange.SixMonths) {
				runDateFilterTitle =
					'Run Date' +
					'(' +
					moment(new Date(dateChange.setMonth(dateChange.getMonth() - 6)))
						.format('MM/DD/YYYY')
						.toString()
						.split('T')[0] +
					' through ' +
					moment(new Date(dateChange.setMonth(dateChange.getMonth() + 12)))
						.format('MM/DD/YYYY')
						.toString()
						.split('T')[0] +
					')'
			} else if (dateRangeId === DateRange.OneYear) {
				runDateFilterTitle =
					'Run Date' +
					'(' +
					moment(new Date(dateChange.setFullYear(dateChange.getFullYear() - 1)))
						.format('MM/DD/YYYY')
						.toString()
						.split('T')[0] +
					' through ' +
					moment(new Date(dateChange.setFullYear(dateChange.getFullYear() + 2)))
						.format('MM/DD/YYYY')
						.toString()
						.split('T')[0] +
					')'
			}
			this.setState({
				runDateFilterTitle: runDateFilterTitle,
			})
		}

		this.setState({
			isSearching: true,
			isDobSearched: searchTerm.dob !== null && typeof searchTerm.dob !== 'undefined' ? true : false,
			isTransactionDateSearched: searchTerm.runDate !== null && typeof searchTerm.runDate !== 'undefined' ? true : false,
			showOrHideNpisFilter: this.props.RequestHistoryStateManager.availableNpis.some((x: { isSelected: any }) => x.isSelected),
			showOrHidePayersFilter: this.props.RequestHistoryStateManager.availablePayers.some((x: { isSelected: any }) => x.isSelected),
			showOrHideStatusFilter: this.props.RequestHistoryStateManager.availableTransactionStatuses.some((x: { isSelected: any }) => x.isSelected),
			showOrHideEligibilityStatusFilter: this.props.RequestHistoryStateManager.availableEligibilityStatuses.some((x: { isSelected: any }) => x.isSelected),
		})
		const id = typeof this.props.match.params.batchRunId !== 'undefined' && this.props.match.params.batchRunId !== null ? parseInt(this.props.match.params.batchRunId) : 0
		return new Promise(resolve => {
			resolve(
				this.props.RequestHistoryStateManager.setRequestHistoryGridCriteria({ ...this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria, searchTerm: searchTerm, page: 1, dateRange: this.state.selectedRunDateRangeId })
					.then(() => {
						this.props.RequestHistoryStateManager.loadCoverageDiscoveryRequestHistoryGridResults(id)
							.then(() => {
								this.setState({
									isSearching: false,
								})
							})
							.catch(() => {
								this.setState({ isSearching: false })
							})
					})
					.catch(() => {
						this.setState({ isSearching: false })
					}),
			)
		})
	}

	handlePayerSearch(searchedVal: string): void {
		const input = searchedVal.toLocaleLowerCase()

		const result = this.searchedPayers.filter(payer => payer.name.toLowerCase().indexOf(input) > -1)

		this.props.RequestHistoryStateManager.setAvailblePayers(result)

		this.setState({
			searchedPayerValue: searchedVal,
			allOnPageSelectedForPayer: this.getAllSelectedForPayer(),
		})
	}

	setIsPageLoadState(val: boolean): void {
		this.setState({
			IsPageLoading: val,
		})
	}

	toggle(): void {
		this.setState({
			modal: !this.state.modal,
		})
	}

	NoDataIndication = (): any => <div className="no-data">{this.props.RequestHistoryStateManager.isDataLoading ? <></> : <span>No result found</span>}</div>

	handleChange = (e: Date | null): void => {
		this.setState({ dateOfBirth: e !== null ? new Date(e) : null })
		if (this.dobSearchTextboxRef.current !== null) this.dobSearchTextboxRef.current.valueAsDate = e !== null ? e : null
		if (e === null) return
		if (e > new Date()) {
			alert('Date of Birth value cannot be a date in the future')
			this.setState({ dateOfBirth: null })
			if (this.dobSearchTextboxRef.current !== null) this.dobSearchTextboxRef.current.valueAsDate = null
			return
		}
		setTimeout(() => this.CheckManualEnteredDate(), 1000)
	}

	handleTransactionDateChange = (e: Date | null): void => {
		this.setState({ transactionDate: e !== null ? new Date(e) : null })
		if (this.transactionDateTextboxRef.current !== null) this.transactionDateTextboxRef.current.valueAsDate = e !== null ? e : null
		if (e === null) {
			this.setState({
				searchedTransactionDate: null,
			})
			return
		}
		if (e > new Date()) {
			alert('Transaction date value cannot be a date in the future')
			this.setState({ transactionDate: null, searchedTransactionDate: null })
			if (this.transactionDateTextboxRef.current !== null) this.transactionDateTextboxRef.current.valueAsDate = null
			return
		}
		setTimeout(() => this.CheckManualEnteredDateForTransaction(), 1000)
		this.setState({
			searchedTransactionDate: e !== null ? new Date(e) : null,
		})
	}

	CheckManualEnteredDate(): void {
		const selectedDate = document.getElementById('dob') as HTMLInputElement
		if (selectedDate != null && selectedDate.value != null && selectedDate.value.match(SettingsManager.DATE_REGULAR_EXPRESSION) === null) {
			alert(selectedDate.value + ' is not valid Date')
			this.setState({ dateOfBirth: null })
			if (this.dobSearchTextboxRef.current !== null) this.dobSearchTextboxRef.current.valueAsDate = null
			return
		}
	}

	CheckManualEnteredDateForTransaction(): void {
		const selectedDate = document.getElementById('runDate') as HTMLInputElement
		if (selectedDate != null && selectedDate.value != null && selectedDate.value.match(SettingsManager.DATE_REGULAR_EXPRESSION) === null) {
			alert(selectedDate.value + ' is not valid Date')
			this.setState({ transactionDate: null, searchedTransactionDate: null })
			if (this.transactionDateTextboxRef.current !== null) this.transactionDateTextboxRef.current.valueAsDate = null
			return
		}
	}
	closeDatePopupOnTab(e: KeyboardEvent): void {
		if (e.key === 'Tab') {
			e.preventDefault()
			const searchRequestHistoryButton = document.getElementById('searchRequestHistoryButton')
			if (searchRequestHistoryButton !== null) {
				const datePicker = this.dobSearchTextboxRef.current as DatePicker
				if (datePicker !== null) {
					datePicker.setOpen(false)
				}
				searchRequestHistoryButton.focus()
			}
		}
	}

	closeDateTransactionPopupOnTab(e: KeyboardEvent): void {
		if (e.key === 'Tab') {
			e.preventDefault()
			const btnSubmitForRequestHistory = document.getElementById('btnSubmitForRequestHistory')
			if (btnSubmitForRequestHistory !== null) {
				const datePicker = this.transactionDateTextboxRef.current as DatePicker
				if (datePicker !== null) {
					datePicker.setOpen(false)
				}
				btnSubmitForRequestHistory.focus()
			}
		}
	}

	handleTableChange = (type: string, args: TableChangeState): void => {
		const newArgs: any = args
		this.tableHeight = typeof document.getElementsByClassName('dataTable')[0] !== 'undefined' ? document.getElementsByClassName('dataTable')[0].clientHeight : this.tableHeight
		if (newArgs.data.length > 0) {
			this.isFirstTimeLoading = false
		} else {
			this.isFirstTimeLoading = true
			this.tableHeight = this.tableHeight - 15
		}
		this.spinnerHeight = typeof document.getElementsByClassName('dataTable')[0] !== 'undefined' ? document.getElementsByClassName('dataTable')[0].clientHeight - 80 : this.spinnerHeight
		const id = typeof this.props.match.params.batchRunId !== 'undefined' && this.props.match.params.batchRunId !== null ? parseInt(this.props.match.params.batchRunId) : 0
		this.props.RequestHistoryStateManager.setRequestHistoryGridCriteriaAndLoad(id, {
			sortOrder: args.sortOrder ? args.sortOrder : this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria.sortOrder,
			sortField: args.sortField ? args.sortField : this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria.sortField,
			page: args.page,
			sizePerPage: args.sizePerPage,
			searchTerm: this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria.searchTerm,
			dateRange: this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria.dateRange,
		})
			.then(() => {
				this.setState({
					allOnPageSelected: this.getAllSelected(),
				})
				if (this.state.isFiltersLoadedFirstTime === false) {
					if (this.state.isStatusLoadedForFilter === false) {
						this.props.RequestHistoryStateManager.loadAvailableTransactionStatuses()
							.catch(error => {
								alert(error)
								this.setState({
									isFiltersLoadedFirstTime: true,
								})
							})
							.then(() => {
								this.setState({
									isStatusLoadedForFilter: true,
									allOnPageSelectedForStatus: this.getAllSelectedForStatus(),
								})
							})
							.then(() => {
								this.props.RequestHistoryStateManager.loadAvailableEligibilityStatuses()
									.catch(error => {
										alert(error)
										this.setState({
											isFiltersLoadedFirstTime: true,
										})
									})
									.then(() => {
										this.setState({
											isStatusLoadedForFilter: true,
											allOnPageSelectedForEligibilityStatus: this.getAllEligibilitySelectedForStatus(),
										})
									})
							})
							.then(() => {
								if (this.state.isNpiLoadedForFilter === false) {
									this.props.RequestHistoryStateManager.loadAvailableNpis()
										.catch(error => {
											alert(error)
											this.setState({
												isFiltersLoadedFirstTime: true,
											})
										})
										.then(() => {
											this.setState({
												isNpiLoadedForFilter: true,
												allOnPageSelectedForNpi: this.getAllSelectedForNpi(),
											})
										})
										.then(() => {
											if (this.state.isPayerLoadedForFilter === false) {
												this.props.RequestHistoryStateManager.loadAvailablePayers()
													.catch(error => {
														alert(error)
														this.setState({
															isFiltersLoadedFirstTime: true,
														})
													})
													.then(() => {
														this.setState({
															isPayerLoadedForFilter: true,
															allOnPageSelectedForPayer: this.getAllSelectedForPayer(),
														})
														this.searchedPayers = this.props.RequestHistoryStateManager.availablePayers
													})
											}
										})
								}
							})
					}
				}
			})
			.then(() => {
				this.isFirstTimeLoading = false
				this.setState({
					isFiltersLoadedFirstTime: true,
				})
			})
			.catch(error => {
				alert(error)
			})
	}

	setDate(e: Date | null): void {
		this.setState({ dateOfBirth: e !== null ? new Date(e) : null })
		if (this.dobSearchTextboxRef.current !== null) this.dobSearchTextboxRef.current.valueAsDate = e !== null ? e : null
	}
	setTransactionDate(e: Date | null): void {
		this.setState({ transactionDate: e !== null ? new Date(e) : null })
		if (this.transactionDateTextboxRef.current !== null) this.transactionDateTextboxRef.current.valueAsDate = e !== null ? e : null
	}
	renderDate(date: Date): React.ReactNode {
		return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000)
	}

	changeStateOfCheckboxesToIntital(): void {
		this.changeStateOfCheckboxesToIntitalForNpi()
		this.changeStateOfCheckboxesToIntitalForPayer()
		this.changeStateOfCheckboxesToIntitalForStatus()
		this.changeStateOfCheckboxesToIntitalForEligibilityStatus()
	}

	changeStateOfCheckboxesToIntitalForNpi(): void {
		this.props.RequestHistoryStateManager.availableNpis.forEach((element: { isSelected: boolean }) => {
			element.isSelected = false
		})
		this.setState({
			allOnPageSelectedForNpi: false,
		})
	}

	changeStateOfCheckboxesToIntitalForPayer(): void {
		this.props.RequestHistoryStateManager.availablePayers.forEach((element: { isSelected: boolean }) => {
			element.isSelected = false
		})
		this.setState({
			allOnPageSelectedForPayer: false,
		})
	}

	changeStateOfCheckboxesToIntitalForStatus(): void {
		this.props.RequestHistoryStateManager.availableTransactionStatuses.forEach((element: { isSelected: boolean }) => {
			element.isSelected = false
		})
		this.setState({
			allOnPageSelectedForStatus: false,
		})
	}

	changeStateOfCheckboxesToIntitalForEligibilityStatus(): void {
		this.props.RequestHistoryStateManager.availableEligibilityStatuses.forEach((element: { isSelected: boolean }) => {
			element.isSelected = false
		})
		this.setState({
			allOnPageSelectedForEligibilityStatus: false,
		})
	}

	clearAll(): void {
		if (this.firstNameSearchTextboxRef.current != null) this.firstNameSearchTextboxRef.current.value = ''
		if (this.lastNameSearchTextboxRef.current != null) this.lastNameSearchTextboxRef.current.value = ''
		if (this.ssnSearchTextboxRef.current != null) this.ssnSearchTextboxRef.current.value = ''
		if (this.dobSearchTextboxRef.current != null) this.dobSearchTextboxRef.current.valueAsDate = null
		if (this.transactionDateTextboxRef.current != null) this.transactionDateTextboxRef.current.valueAsDate = null
		this.setAsyncState({
			dateOfBirth: null,
			isDobSearched: false,
			transactionDate: null,
			isTransactionDateSearched: false,
			selectedRunDateRangeId: 0,
			checkedRunDate: false,
		} as IRequestHistoryState)
			.then(() => this.changeStateOfCheckboxesToIntital())
			.then(() => this.handleSearch())
			.catch(err => console.error(err))

		this.setState({
			npiClicked: false,
			statusClicked: true,
			payerClicked: false,
		})
		this.isFirstTimeLoading = true
	}

	showOrHideClearAll(): any {
		const firstName = this.firstNameSearchTextboxRef.current ? this.firstNameSearchTextboxRef.current.value : ''
		const lastName = this.lastNameSearchTextboxRef.current ? this.lastNameSearchTextboxRef.current.value : ''
		const ssn = this.ssnSearchTextboxRef.current ? this.ssnSearchTextboxRef.current.value : ''
		const dobSearched = this.state.isDobSearched
		const transactionDateSearched = this.state.isTransactionDateSearched
		if (isEmpty(firstName) && isEmpty(lastName) && isEmpty(ssn) && !this.state.showOrHideNpisFilter && !this.state.showOrHidePayersFilter && !this.state.showOrHideStatusFilter && !this.state.showOrHideEligibilityStatusFilter && !dobSearched && !transactionDateSearched) {
			return null
		} else {
			return (
				<div id="clearAll">
					<span onClick={(): void => this.clearAll()}>Clear All</span>
				</div>
			)
		}
	}

	clearFilterForPatientSearch(): any {
		if (this.firstNameSearchTextboxRef.current != null) this.firstNameSearchTextboxRef.current.value = ''
		if (this.lastNameSearchTextboxRef.current != null) this.lastNameSearchTextboxRef.current.value = ''
		if (this.ssnSearchTextboxRef.current != null) this.ssnSearchTextboxRef.current.value = ''
		if (this.dobSearchTextboxRef.current != null) this.dobSearchTextboxRef.current.valueAsDate = null

		this.setAsyncState({
			dateOfBirth: null,
		} as IRequestHistoryState)
			.then(() => this.handleSearch())
			.catch(err => console.error(err))
	}

	showOrHideFilterResultsForPatientSearch(): any {
		const firstName = this.firstNameSearchTextboxRef.current ? this.firstNameSearchTextboxRef.current.value : ''
		const lastName = this.lastNameSearchTextboxRef.current ? this.lastNameSearchTextboxRef.current.value : ''
		const ssn = this.ssnSearchTextboxRef.current ? this.ssnSearchTextboxRef.current.value : ''
		const dobSearched = this.state.isDobSearched

		if (isEmpty(firstName) && isEmpty(lastName) && isEmpty(ssn) && !dobSearched) {
			return null
		} else {
			if (!isEmpty(firstName) || !isEmpty(lastName) || !isEmpty(ssn) || dobSearched) {
				return (
					<div id="filters">
						Patient Search
						<span id="filterClose" onClick={(): void => this.clearFilterForPatientSearch()}>
							{' '}
						</span>
					</div>
				)
			}
		}
	}

	clearFilterForNpis(): any {
		this.changeStateOfCheckboxesToIntitalForNpi()
		this.handleSearch()
		this.setState({
			npiClicked: false,
			statusClicked: true,
			payerClicked: false,
		})
	}

	showOrHideFilterResultsForNpis(): any {
		if (!this.state.showOrHideNpisFilter) {
			return null
		} else {
			if (this.state.showOrHideNpisFilter) {
				return (
					<div id="filters">
						Facilities
						<span id="filterClose" onClick={(): void => this.clearFilterForNpis()}>
							{' '}
						</span>
					</div>
				)
			}
		}
	}

	clearFilterForPayers(): any {
		this.changeStateOfCheckboxesToIntitalForPayer()
		this.handleSearch()
		this.setState({
			npiClicked: false,
			statusClicked: true,
			payerClicked: false,
		})
	}

	showOrHideFilterResultsForPayers(): any {
		if (!this.state.showOrHidePayersFilter) {
			return null
		} else {
			if (this.state.showOrHidePayersFilter) {
				return (
					<div id="filters">
						Payers
						<span id="filterClose" onClick={(): void => this.clearFilterForPayers()}>
							{' '}
						</span>
					</div>
				)
			}
		}
	}

	clearFilterForTransactionDate(): any {
		if (this.transactionDateTextboxRef.current != null) this.transactionDateTextboxRef.current.valueAsDate = null

		this.setAsyncState({
			transactionDate: null,
			selectedRunDateRangeId: 0,
			checkedRunDate: false,
		} as IRequestHistoryState)
			.then(() => this.handleSearch())
			.catch(err => console.error(err))
	}

	showOrHideFilterResultsForTransactionDate(): any {
		if (this.state.isTransactionDateSearched === false || this.state.checkedRunDate === false) {
			return null
		} else {
			return (
				<div id="filters">
					{this.state.runDateFilterTitle}
					<span id="filterClose" onClick={(): void => this.clearFilterForTransactionDate()}>
						{' '}
					</span>
				</div>
			)
		}
	}

	clearFilterForStatues(): any {
		this.changeStateOfCheckboxesToIntitalForEligibilityStatus()
		this.changeStateOfCheckboxesToIntitalForStatus()
		this.handleSearch()
		this.setState({
			npiClicked: false,
			statusClicked: true,
			payerClicked: false,
		})
	}

	showOrHideFilterResultsForStatuses(): any {
		if (!this.state.showOrHideStatusFilter) {
			return null
		} else {
			if (this.state.showOrHideStatusFilter) {
				return (
					<div id="filters">
						Transaction Status
						<span id="filterClose" onClick={(): void => this.clearFilterForStatues()}>
							{' '}
						</span>
					</div>
				)
			}
		}
	}

	showOrHideFilterResultsForEligibilityStatuses(): any {
		if (!this.state.showOrHideEligibilityStatusFilter) {
			return null
		} else {
			if (this.state.showOrHideEligibilityStatusFilter) {
				return (
					<div id="filters">
						Eligibility Status
						<span id="filterClose" onClick={(): void => this.clearFilterForStatues()}>
							{' '}
						</span>
					</div>
				)
			}
		}
	}

	getAllSelected(): boolean {
		const countSelected = this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridResults.items.filter(item => item.isSelected).length
		const totalCount = this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridResults.items.length
		return countSelected === totalCount
	}

	getAllSelectedForNpi(): boolean {
		const countSelected = this.props.RequestHistoryStateManager.availableNpis.filter(item => item.isSelected).length
		const totalCount = this.props.RequestHistoryStateManager.availableNpis.length
		return countSelected === totalCount
	}

	getAllSelectedForStatus(): boolean {
		const countSelected = this.props.RequestHistoryStateManager.availableTransactionStatuses.filter(item => item.isSelected).length
		const totalCount = this.props.RequestHistoryStateManager.availableTransactionStatuses.length
		return countSelected === totalCount
	}

	getAllEligibilitySelectedForStatus(): boolean {
		const countSelected = this.props.RequestHistoryStateManager.availableEligibilityStatuses.filter(item => item.isSelected).length
		const totalCount = this.props.RequestHistoryStateManager.availableEligibilityStatuses.length
		return countSelected === totalCount
	}

	getAllSelectedForPayer(): boolean {
		const countSelected = this.props.RequestHistoryStateManager.availablePayers.filter(item => item.isSelected).length
		const totalCount = this.props.RequestHistoryStateManager.availablePayers.length
		return countSelected === totalCount
	}

	renderTransactionLabel(): any {
		const len = typeof this.props.RequestHistoryStateManager.selectedTransactionIds !== 'undefined' ? this.props.RequestHistoryStateManager.selectedTransactionIds.size : 0
		if (len > 0) {
			return <label>You can export the selected transactions</label>
		} else {
			return <label>You must select at least one transactions</label>
		}
	}

	handleTransactionSelectChange(row: ICoverageDiscoveryRequestHistoryGridRow, value: boolean): void {
		this.props.RequestHistoryStateManager.setTransactionIdSelected(row.id, value)
		row.isSelected = value
		this.setState({ allOnPageSelected: this.getAllSelected() })
	}

	handlePayerSelectedChange(payer: IPayer, value: boolean): void {
		this.props.RequestHistoryStateManager.setPayerValue(payer.id, value)
		payer.isSelected = value
		this.setState({ allOnPageSelectedForPayer: this.getAllSelectedForPayer() })
	}

	handleNpiSelectedChange(npi: INpi, value: boolean): void {
		this.props.RequestHistoryStateManager.setNpiValue(npi.id, value)
		npi.isSelected = value
		this.setState({ allOnPageSelectedForNpi: this.getAllSelectedForNpi() })
	}

	handleStatusSelectedChange(status: ITransactionStatus, value: boolean): void {
		this.props.RequestHistoryStateManager.setTransactionStatus(status.id, value)
		status.isSelected = value
		this.setState({ allOnPageSelectedForStatus: this.getAllSelectedForStatus() })
	}

	handleEligibilityStatusSelectedChange(status: IEligibilityStatus, value: boolean): void {
		this.props.RequestHistoryStateManager.setEligibilityStatus(status.id, value)
		status.isSelected = value
		this.setState({ allOnPageSelectedForEligibilityStatus: this.getAllEligibilitySelectedForStatus() })
	}

	handleReviewedSelectChange(row: ICoverageDiscoveryRequestHistoryGridRow, value: boolean): void {
		if (value === false) {
			const message = 'You are unchecking the reviewed data which might be checked by other user. Are you sure you want to continue?'
			const confirmationStatus = window.confirm(message)
			if (confirmationStatus === true) {
				this.setState({
					showReviewedUserAndDate: false,
				})
				row.reviewed = value
				this.props.RequestHistoryStateManager.updateReviewed(row.id, row.reviewed)
					.then((response: any) => {
						if (response) {
							row.reviewedDate = response.reviewedDate
							row.reviewedByUser = response.reviewedByUser
						}
					})
					.catch(error => {
						alert(error)
					})
			}
		} else {
			row.reviewed = value
			this.props.RequestHistoryStateManager.updateReviewed(row.id, row.reviewed)
				.then((response: any) => {
					if (response) {
						row.reviewedDate = response.reviewedDate
						row.reviewedByUser = response.reviewedByUser
					}
					this.setState({
						showReviewedUserAndDate: true,
					})
				})
				.catch(error => {
					alert(error)
				})
		}
	}

	handleTransactionSelectAll(): void {
		const allSelected: boolean = this.state.allOnPageSelected
		if (allSelected) {
			//All on page are selected, so clicking the "select all" header should de-select all:
			for (const row of this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridResults.items.filter(x => x.transactionStatusId !== TransactionStatus.Pending)) {
				this.handleTransactionSelectChange(row, false)
			}
		} else {
			//Not all were initially selected, so we should now select all
			for (const row of this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridResults.items.filter(x => x.transactionStatusId !== TransactionStatus.Pending)) {
				if (!row.isSelected) this.handleTransactionSelectChange(row, true)
			}
		}
	}

	handlePayerSelectAll(): void {
		const allSelected: boolean = this.state.allOnPageSelectedForPayer
		if (allSelected) {
			for (const row of this.props.RequestHistoryStateManager.availablePayers) {
				this.handlePayerSelectedChange(row, false)
			}
		} else {
			for (const row of this.props.RequestHistoryStateManager.availablePayers) {
				if (!row.isSelected) this.handlePayerSelectedChange(row, true)
			}
		}
	}

	handleNpiSelectAll(): void {
		const allSelected: boolean = this.state.allOnPageSelectedForNpi
		if (allSelected) {
			for (const row of this.props.RequestHistoryStateManager.availableNpis) {
				this.handleNpiSelectedChange(row, false)
			}
		} else {
			for (const row of this.props.RequestHistoryStateManager.availableNpis) {
				if (!row.isSelected) this.handleNpiSelectedChange(row, true)
			}
		}
	}

	handleStatusSelectAll(): void {
		const allSelected: boolean = this.state.allOnPageSelectedForStatus
		if (allSelected) {
			for (const row of this.props.RequestHistoryStateManager.availableTransactionStatuses) {
				this.handleStatusSelectedChange(row, false)
			}
		} else {
			for (const row of this.props.RequestHistoryStateManager.availableTransactionStatuses) {
				if (!row.isSelected) this.handleStatusSelectedChange(row, true)
			}
		}
	}

	handleEligibilityStatusSelectAll(): void {
		const allSelected: boolean = this.state.allOnPageSelectedForEligibilityStatus
		if (allSelected) {
			for (const row of this.props.RequestHistoryStateManager.availableEligibilityStatuses) {
				this.handleEligibilityStatusSelectedChange(row, false)
			}
		} else {
			for (const row of this.props.RequestHistoryStateManager.availableEligibilityStatuses) {
				if (!row.isSelected) this.handleEligibilityStatusSelectedChange(row, true)
			}
		}
	}

	ClearFilterOnCancel(): void {
		if (this.state.searchedPayerValue !== '') {
			this.props.RequestHistoryStateManager.setAvailblePayers(this.searchedPayers)

			this.setState({
				searchedPayerValue: '',
			})
		}
		if (!this.state.showOrHideNpisFilter && !this.state.showOrHidePayersFilter && !this.state.showOrHideStatusFilter && !this.state.showOrHideEligibilityStatusFilter && !this.state.isTransactionDateSearched) {
			this.changeStateOfCheckboxesToIntital()
			this.setState({
				transactionDate: null,
				selectedRunDateRangeId: 0,
				checkedRunDate: false,
				statusClicked: true,
				npiClicked: false,
				payerClicked: false,
			})
		}
	}

	handleCheck(): any {
		this.setState({
			checkedRunDate: !this.state.checkedRunDate,
		})
	}

	renderNpi = (): any => {
		if (this.state.npiClicked) {
			if (this.state.isNpiLoadedForFilter) {
				return this.props.RequestHistoryStateManager.availableNpis === null || typeof this.props.RequestHistoryStateManager.availableNpis === 'undefined' || this.props.RequestHistoryStateManager.availableNpis.length === 0 ? (
					<div id="facilityMessage">No facilities assigned to this user. Please contact administrator</div>
				) : (
					<div className="filterHistory">
						<div className="row-fluid form-header" id="filterHistoryHeader">
							<div className="abc">
								<div id="selectAll">
									<label id="npiName">FACILITY</label>
									<span
										className="anchorClassForRequestHistory"
										onClick={(): void => {
											this.handleNpiSelectAll()
										}}
									>
										{this.state.allOnPageSelectedForNpi ? 'UNSELECT ALL' : 'SELECT ALL'}
									</span>
								</div>
							</div>
						</div>
						<div id="checkBoxesForNpis">
							<Row>
								<Col>
									<div id="divForCheckBox">
										{this.props.RequestHistoryStateManager.availableNpis.map(c => {
											return (
												<div key={c.id} id="box">
													<Input type="checkbox" name="checkNpi[]" checked={c.isSelected} onChange={(e): void => this.handleNpiSelectedChange(c, e.target.checked)} value={c.id} />
													&nbsp;&nbsp;&nbsp;&nbsp;{c.name}
												</div>
											)
										})}
									</div>
								</Col>
							</Row>
						</div>
					</div>
				)
			}
		}
	}

	renderPayer = (): any => {
		if (this.state.payerClicked) {
			if (this.state.isPayerLoadedForFilter) {
				return this.props.RequestHistoryStateManager.availablePayers === null || typeof this.props.RequestHistoryStateManager.availablePayers === 'undefined' || this.props.RequestHistoryStateManager.availablePayers.length === 0 ? (
					<div id="facilityMessage">
						<Input onChange={(e): void => this.handlePayerSearch(e.target.value)} type="text" id="searchFilter" className="searchByPayerFilter" placeholder="Search by Payer" value={this.state.searchedPayerValue} />
						No payer was found. Please contact administrator
					</div>
				) : (
					<div className="filterHistory">
						<Input onChange={(e): void => this.handlePayerSearch(e.target.value)} type="text" id="searchFilter" className="searchByPayerFilter" placeholder="Search by Payer" value={this.state.searchedPayerValue} />
						<div className="row-fluid form-header" id="filterHistoryHeader">
							<div className="abc">
								<div id="selectAll">
									<label id="npiName">Payer</label>
									<span
										className="anchorClassForRequestHistory"
										onClick={(): void => {
											this.handlePayerSelectAll()
										}}
									>
										{this.state.allOnPageSelectedForPayer ? 'UNSELECT ALL' : 'SELECT ALL'}
									</span>
								</div>
							</div>
						</div>
						<div id="checkBoxesForNpis">
							<Row>
								<Col>
									<div id="divForCheckBox">
										{this.props.RequestHistoryStateManager.availablePayers.map(c => {
											return (
												<div key={c.id} id="box">
													<Input type="checkbox" name="checkPayer[]" checked={c.isSelected} onChange={(e): void => this.handlePayerSelectedChange(c, e.target.checked)} value={c.id} />
													&nbsp;&nbsp;&nbsp;&nbsp;{c.name}
												</div>
											)
										})}
									</div>
								</Col>
							</Row>
						</div>
					</div>
				)
			}
		}
	}

	renderStatusAndDate = (): any => {
		if (this.state.statusClicked) {
			return this.props.RequestHistoryStateManager.availableTransactionStatuses === null || typeof this.props.RequestHistoryStateManager.availableTransactionStatuses === 'undefined' || this.props.RequestHistoryStateManager.availableTransactionStatuses.length === 0 ? (
				<div id="facilityMessage">No status was found. Please contact administrator</div>
			) : (
				<div className="filterHistory">
					<div className="row-fluid form-header" id="filterHistoryHeader">
						<div className="abc">
							<div id="selectAll">
								<label id="npiName">Transaction Status</label>
								<span
									className="anchorClassForRequestHistory"
									onClick={(): void => {
										this.handleStatusSelectAll()
									}}
								>
									{this.state.allOnPageSelectedForStatus ? 'UNSELECT ALL' : 'SELECT ALL'}
								</span>
							</div>
						</div>
					</div>
					<div id="checkBoxesStatus">
						<div id="divForCheckBox">
							{this.props.RequestHistoryStateManager.availableTransactionStatuses.map(c => {
								return (
									<div key={c.id} id="statusBox">
										<Input type="checkbox" name="checkStatus[]" checked={c.isSelected} onChange={(e): void => this.handleStatusSelectedChange(c, e.target.checked)} value={c.id} />
										<img alt={c.name} src={`img/${this.state.imageSrc[c.id - 1]}.png`}></img>&nbsp;&nbsp;&nbsp;&nbsp;{c.name}
									</div>
								)
							})}
						</div>
					</div>
					<div className="row-fluid form-header" id="filterHistoryHeader" style={{ marginRight: '5px' }}>
						<div className="dateClass">
							<div id="selectAll">
								<label id="npiName">Transaction Date</label>
							</div>
						</div>
					</div>
					<div id="bodyContentForFilterHistoryTextbox">
						<div id="textBoxForFilterHistory">
							<div>
								<div id="statusBox" style={{ marginTop: '-16px' }}>
									<Input type="checkbox" name="checkTransactionDate[]" checked={this.state.checkedRunDate} onChange={(): void => this.handleCheck()} />
								</div>
								<div>
									<Label id="labelForDate">Run Date:</Label>
								</div>
								<div>
									<Input type="select" id="dropDownForDateRange" name="dropdownDates" value={this.state.selectedRunDateRangeId} onChange={(e): void => this.loadSelectedDateById(e)}>
										{typeof this.props.RequestHistoryStateManager.runDateDropdownList !== 'undefined' &&
											this.props.RequestHistoryStateManager.runDateDropdownList.map(c => (
												<option key={c.id} value={c.id} style={{ fontSize: '15px' }}>
													{c.selectionText}
												</option>
											))}
									</Input>
								</div>
								<div style={{ marginLeft: '330px', marginTop: '-44px' }}>
									<DatePicker
										popperProps={{
											positionFixed: true,
										}}
										ref={this.transactionDateTextboxRef}
										onKeyDown={this.closeDateTransactionPopupOnTab}
										selected={this.state.transactionDate}
										className="dob input-110 float-left rounded-lg"
										placeholderText="Date(mm/dd/yyyy)"
										showYearDropdown
										showMonthDropdown
										peekNextMonth
										dropdownMode="select"
										name="rundate"
										id="rundate"
										customInput={<MaskedInput type="text" mask={[/[01]/, /\d/, '/', /[0-3]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]} />}
										onChange={(e): void => this.handleTransactionDateChange(e)}
										popperPlacement="bottom"
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="row-fluid form-header" id="filterHistoryHeader">
						<div className="abc">
							<div id="selectAll">
								<label id="npiName">Eligibility Status</label>
								<span
									className="anchorClassForRequestHistory"
									onClick={(): void => {
										this.handleEligibilityStatusSelectAll()
									}}
								>
									{this.state.allOnPageSelectedForEligibilityStatus ? 'UNSELECT ALL' : 'SELECT ALL'}
								</span>
							</div>
						</div>
					</div>
					<div id="checkBoxesForNpis" className="row-fluid form-header" style={{ height: '250px' }}>
						<Row>
							<Col>
								<div id="divForCheckBox">
									{this.props.RequestHistoryStateManager.availableEligibilityStatuses.map(c => {
										return (
											<div key={c.id} id="box">
												<Input type="checkbox" name="checkStatus[]" checked={c.isSelected} onChange={(e): void => this.handleEligibilityStatusSelectedChange(c, e.target.checked)} value={c.id} />
												&nbsp;&nbsp;&nbsp;&nbsp;{c.name}
											</div>
										)
									})}
								</div>
							</Col>
						</Row>
					</div>
				</div>
			)
		}
	}

	loadSelectedDateById(event: React.FormEvent<HTMLInputElement>): any {
		if (this.transactionDateTextboxRef.current !== null) {
			this.transactionDateTextboxRef.current.valueAsDate = typeof this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria.searchTerm.runDate !== 'undefined' ? this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria.searchTerm.runDate : null
		}
		this.setAsyncState({
			selectedRunDateRangeId: event.currentTarget.value,
		} as IRequestHistoryState)
	}

	functionNpiClicked(): any {
		this.setState({
			npiClicked: true,
			payerClicked: false,
			statusClicked: false,
		})
	}

	functionPayerClicked(): any {
		this.setState({
			npiClicked: false,
			payerClicked: true,
			statusClicked: false,
		})
	}

	functionStatusClicked(): any {
		this.setState({
			npiClicked: false,
			payerClicked: false,
			statusClicked: true,
		})
	}

	toggleDropDown(): any {
		this.setState({
			dropdownOpen: !this.state.dropdownOpen,
		})
	}

	toggleModalPopupOnSelection(): any {
		this.setState({
			modalForTransaction: !this.state.modalForTransaction,
		})
	}

	toggleModalPopupOnSubmissionOfrequest(): any {
		this.setState({
			modalForFinalMessage: !this.state.modalForFinalMessage,
		})
	}

	toggleModalPopupOnViewReport(): any {
		this.setState({
			OkButtonClicked: this.props.RequestHistoryStateManager.isReportAvailableToBeViewed,
			showDeleteSuccessMessage: false,
			modalForReportInfo: !this.state.modalForReportInfo,
		})
	}

	triggerEventBasedOnClickOfContinue(): any {
		this.fetchReportsOnReportLinkClick()
		this.setState({
			modalForReportInfo: true,
			dropdownOpen: false,
		})
	}

	triggerEventBasedOnTransactionCount(): any {
		const len = this.props.RequestHistoryStateManager.selectedTransactionIds.size
		this.setState({
			dropdownOpen: false,
		})
		if (len > SettingsManager.COVERAGE_DISCOVERY_TRANSACTION_EXPORT_LIMIT) {
			if (len > SettingsManager.COVERAGE_DISCOVERY_TRANSACTION_EXPORT_MAXLIMIT) {
				alert(`Total transactions selected:${len}. You have exceeded the maximum limit of transactions selection for export.`)
			} else {
				this.setState({
					modalForTransaction: true,
				})
			}
		} else {
			this.setState({
				modalForExport: true,
			})
			this.spinnerHeight = typeof document.getElementsByClassName('dataTable')[0] !== 'undefined' ? document.getElementsByClassName('dataTable')[0].clientHeight - 65 : this.spinnerHeight
			this.tableHeight = typeof document.getElementsByClassName('dataTable')[0] !== 'undefined' ? document.getElementsByClassName('dataTable')[0].clientHeight : this.tableHeight
			const ids = Array.from(this.props.RequestHistoryStateManager.selectedTransactionIds.keys())
			this.props.RequestHistoryStateManager.isDataLoading = true
			if (!this.isLoading) {
				this.isLoading = true
				this.props.RequestHistoryStateManager.sendSelectedTransactionIdsForLessThanLimit(ids)
					.then((response: any) => {
						const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
						fileSaver.saveAs(blob, this.getExportReportFileName())
						this.setState({
							showErrorMessage: false,
							errorMessage: '',
						})
						this.props.RequestHistoryStateManager.isDataLoading = false
						this.isLoading = false
					})
					.catch(error => {
						this.setState({ showErrorMessage: true, errorMessage: error.toString() })
						this.props.RequestHistoryStateManager.isDataLoading = false
						this.isLoading = false
					})
			}
		}
	}

	/*** To get Date string in the format of YYYYMMDDHHMMSS for file name*/
	getExportReportFileName(): string {
		const dateString = moment(new Date()).format('YYYYMMDDHHmmss')
		return `InsuranceDiscoveryRequestReport_${dateString}.xlsx`
	}

	sendTransactionIdsForExportRequestJob(): any {
		const fileName = this.getExportReportFileName()
		const ids = Array.from(this.props.RequestHistoryStateManager.selectedTransactionIds.keys())
		const batchRunId = typeof this.props.match.params.batchRunId !== 'undefined' && this.props.match.params.batchRunId !== null ? parseInt(this.props.match.params.batchRunId) : 0
		this.props.RequestHistoryStateManager.sendSelectedTransactionIdsForMoreThanLimit(fileName, batchRunId, ids)
			.catch(error => {
				alert(error)
			})
			.then(() =>
				this.setState({
					modalForFinalMessage: this.props.RequestHistoryStateManager.checkExportRequestSubmission,
				}),
			)
	}

	toggleValidationMessageForDelete(): void {
		this.setState({
			showDeleteSuccessMessage: !this.state.showDeleteSuccessMessage,
			deleteSuccessMessage: '',
		})
	}

	deleteReport(id: number): any {
		this.props.RequestHistoryStateManager.deleteSelectedReport(id)
			.then(() => {
				this.props.RequestHistoryStateManager.loadViewReportGridresults()
				this.setState({
					OkButtonClicked: this.props.RequestHistoryStateManager.isReportAvailableToBeViewed,
				})
			})
			.then(() => {
				this.setState({
					showDeleteSuccessMessage: true,
					deleteSuccessMessage: 'Requested Report has been deleted successfully!',
				})
			})
			.catch(error => {
				alert(error)
			})
	}

	downloadReport(id: number, fileName: string): any {
		this.props.RequestHistoryStateManager.downloadSelectedReport(id)
			.then((response: any) => {
				const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
				fileSaver.saveAs(blob, fileName)
				this.setState({
					showErrorMessage: false,
					errorMessage: '',
				})
			})
			.catch(error => {
				this.setState({ showErrorMessage: true, errorMessage: error.toString() })
			})
	}

	fetchReportsOnReportLinkClick(): any {
		this.props.RequestHistoryStateManager.loadViewReportGridresults()
			.then(() => {
				this.setState({
					OkButtonClicked: this.props.RequestHistoryStateManager.isReportAvailableToBeViewed,
				})
			})
			.catch(error => {
				alert(error)
			})
	}

	render(): React.ReactNode {
		if (this.state.IsPageLoading) {
			return (
				<div>
					<TopPart pagesource="history" />
					<div className="row tab-content">
						<div className="spinnerPage">
							<Spinner animation="border" role="status" />
						</div>
					</div>
				</div>
			)
		} else {
			return (
				<div className="width100P">
					<TopPart pagesource="history" />
					<div className="row  tab-content">
						<div className="width100P">
							<div className="row validationCtnr">
								<ValidationMessage showValidationMessage={this.state.showErrorMessage} MessageType={MessageTypes.Error} validationMessage={this.state.errorMessage} toggleAction={this.toggleValidationMessageShow} />
							</div>
							<div className="contentBody">
								<Modal modalClassname="mdlForExportRequest" isOpen={this.state.modalForReportInfo} fade={this.state.fadeForReportInfo} toggle={(): void => this.toggleModalPopupOnViewReport()} id="modalForfilterHistory">
									<h3 id="headingForExportRequestModal">Insurance Discovery Export Results</h3>
									<ModalBody>
										<Form>
											{this.state.showDeleteSuccessMessage && window.scrollTo(0, 0)}
											<ValidationMessage showValidationMessage={this.state.showDeleteSuccessMessage} MessageType={MessageTypes.Success} validationMessage={this.state.deleteSuccessMessage} toggleAction={this.toggleValidationMessageForDelete} />
											<Observer>
												{(): any => (
													<BootstrapTable
														loading={this.props.RequestHistoryStateManager.isDataLoading}
														id="tableForReport"
														keyField="id"
														classes="dataTable"
														bootstrap4
														hover
														condensed
														remote
														bordered={false}
														noDataIndication={(): React.ReactNode => <this.NoDataIndication />}
														overlay={overlayFactory({
															spinner: true,
															styles: {
																spinner: (base: any) => ({
																	...base,
																	margin: `0px auto ${this.spinnerHeight}px auto !important`,
																	'& svg circle': {
																		stroke: 'rgba(122, 122, 122,1)',
																	},
																}),
																overlay: (base: any) => ({
																	...base,
																	background: 'rgba(243, 242, 239,0.5)',
																	'margin-top': `${this.isFirstTimeLoading ? 0 : 30}px!important`,
																	height: this.tableHeight + 'px !important',
																}),
															},
														})}
														data={this.props.RequestHistoryStateManager.coverageDiscoveryViewReportGridResults.items.slice()}
														defaultSorted={[
															{
																dataField: 'id',
																order: 'desc',
															},
														]}
														columns={[
															{
																dataField: 'name',
																text: 'Selected Transactions Export Request',
																sort: false,
																headerStyle: (): Record<string, string> => {
																	return {
																		width: '13%',
																	}
																},
																formatter: (cell: JSX.Element, row: ICoverageDiscoveryViewReportGrid): JSX.Element => {
																	return (
																		<Button variant="link" className="downloadReportLink" onClick={(): void => this.downloadReport(row.id, row.name)}>
																			{row.name}
																		</Button>
																	)
																},
															},
															{
																dataField: 'requestDate',
																text: 'Request Date',
																sort: '',
																headerStyle: (): Record<string, string> => {
																	return { width: '10%' }
																},
																formatter: (cell: JSX.Element, row: ICoverageDiscoveryViewReportGrid): JSX.Element => {
																	return <Moment format="MM/DD/YYYY">{row.requestDate}</Moment>
																},
															},
															{
																dataField: 'id',
																text: 'Delete',
																sort: false,
																headerStyle: (): Record<string, string> => {
																	return { width: '5%' }
																},
																formatter: (cell: JSX.Element, row: ICoverageDiscoveryViewReportGrid): JSX.Element => {
																	return (
																		<div>
																			<span onClick={(): void => this.deleteReport(row.id)}>
																				<img id="deleteImg" alt="Delete Report" src="img/Remove.png"></img>
																			</span>
																		</div>
																	)
																},
															},
														]}
													/>
												)}
											</Observer>
										</Form>
									</ModalBody>
									<ModalFooter>
										<Button id="btnSubmitForRequestHistory" onClick={(): void => this.toggleModalPopupOnViewReport()}>
											OK
										</Button>
									</ModalFooter>
								</Modal>
								<Modal modalClassName="mdlForExportRequest" isOpen={this.state.modalForTransaction} fade={this.state.fadeForTransaction} toggle={(): void => this.toggleModalPopupOnSelection()} id="modalForfilterHistory">
									<h3 id="headingForExportRequestModal">Insurance Discovery Export Request</h3>
									<ModalBody>
										<Form>
											<Row>You have selected more than {SettingsManager.COVERAGE_DISCOVERY_TRANSACTION_EXPORT_LIMIT} transactions for export. Your request will be processed by the system and you will be able to download the report on completion of this request.</Row>
											<Row>Are you sure you want to continue?</Row>
										</Form>
									</ModalBody>
									<ModalFooter>
										<Button
											id="btnSubmitForRequestHistory"
											onClick={(): void => {
												this.sendTransactionIdsForExportRequestJob()
												this.toggleModalPopupOnSelection()
											}}
										>
											Yes
										</Button>{' '}
										<Button id="btnCancelForRequestHistory" onClick={(): void => this.toggleModalPopupOnSelection()}>
											No
										</Button>
									</ModalFooter>
								</Modal>
								<Modal modalClassName="mdlForExportRequest" isOpen={this.state.modalForFinalMessage} fade={this.state.fadeForFinalMessage} toggle={(): void => this.toggleModalPopupOnSubmissionOfrequest()} id="modalForfilterHistory">
									<h3 id="headingForExportRequestModal">Insurance Discovery Export Request</h3>
									<ModalBody>
										<Form>
											<Row>Your request has been successfully submitted.</Row>
											<Row>You can retrieve the report by clicking the "View Reports (Exported Requests)" button on the History page, once it is available.</Row>
										</Form>
									</ModalBody>
									<ModalFooter>
										<Button id="btnSubmitForRequestHistory" onClick={(): void => this.toggleModalPopupOnSubmissionOfrequest()}>
											OK
										</Button>
									</ModalFooter>
								</Modal>
								<Modal modalClassName="mdlRequestHistory" isOpen={this.state.modal} fade={this.state.fade} toggle={(): void => this.toggle()} id="modalForfilterHistory">
									<ModalHeader>
										<span>
											<h3 id="headingForFilter" style={{ display: 'inline' }}>
												Filter Responses
											</h3>
										</span>
										<span
											id="closeModalForFilter"
											style={{ display: 'inline', float: 'right' }}
											onClick={(): void => {
												this.toggle()
												this.ClearFilterOnCancel()
											}}
										>
											&times;
										</span>
									</ModalHeader>
									<ModalBody style={{ maxHeight: 'fit-content' }}>
										<Form>
											<Row>
												<div id="tabsection">
													<ul id="codeTabs">
														<li>
															<div onClick={(): void => this.functionStatusClicked()} style={{ color: this.state.statusClicked ? '#8f8f8f' : '#003d79' }} id="tabLink">
																Status & Date
															</div>
														</li>
														<li>
															<div onClick={(): void => this.functionNpiClicked()} style={{ color: this.state.npiClicked ? '#8f8f8f' : '#003d79' }} id="tabLink">
																Facility
															</div>
														</li>
														<li>
															<div onClick={(): void => this.functionPayerClicked()} style={{ color: this.state.payerClicked ? '#8f8f8f' : '#003d79' }} id="tabLink">
																Payer
															</div>
														</li>
													</ul>
												</div>
												<div id="contentSection">
													<div id="tabForForm">
														{this.renderNpi()}
														{this.renderPayer()}
														{this.renderStatusAndDate()}
													</div>
												</div>
											</Row>
										</Form>
									</ModalBody>
									<ModalFooter id="modalFooter">
										<Button
											id="btnCancelForRequestHistory"
											onClick={(): void => {
												this.reloadPrevDetailsOnCancel(this.state.filteredResponseDetails)
												this.toggle()
												this.ClearFilterOnCancel()
											}}
										>
											Cancel
										</Button>
										<Button
											id="btnSubmitForRequestHistory"
											onClick={(): Promise<void> =>
												this.handleSearch().then(() => {
													this.toggle()
												})
											}
										>
											Apply Selections
										</Button>{' '}
									</ModalFooter>
								</Modal>
								<Modal modalClassName="mdlForExportRequest" isOpen={this.state.modalForExport} fade={this.state.fadeForExport} toggle={(): void => this.toggleExportModalPopupOnSelection()} id="modalForExportRequest">
									<h3 id="headingForExportRequestModal">Insurance Discovery Export Request</h3>
									<ModalBody>
										<Form>
											<Row>Your request has been submitted. Your file will download when the report is ready. This may take some time.</Row>
										</Form>
									</ModalBody>
									<ModalFooter>
										<Button id="btnCancelForExportRequest" onClick={(): void => this.toggleExportModalPopupOnSelection()}>
											Ok
										</Button>
									</ModalFooter>
								</Modal>

								<div className="results">
									<form>
										<Row>
											<Col xs="2" className="width130p">
												<Button
													color="primary"
													className={this.props.RequestHistoryStateManager.isDataLoading ? 'filterButton disabled' : 'filterButton'}
													onClick={(): void => {
														this.toggle()
														this.loadCurrentValues()
													}}
												>
													Filter History
												</Button>
											</Col>
											<Col xs="9">
												<div className="patientSearch">
													<label>Search History By Patient or Guarantor</label>
													<br />
													<Input type="text" id="lastNameSearchFilter" placeholder="Last Name" className="input-110 float-left rounded-lg" innerRef={this.lastNameSearchTextboxRef} />
													<Input type="text" id="firstNameSearchFilter" placeholder="First Name" className="input-110 float-left rounded-lg" innerRef={this.firstNameSearchTextboxRef} />
													<Input type="text" id="ssnSearchFilter" placeholder="SSN" className="input-110 float-left rounded-lg" innerRef={this.ssnSearchTextboxRef} />
													<div style={{ display: 'inline-block', zIndex: 3, width: '22%' }}>
														<DatePicker ref={this.dobSearchTextboxRef} onKeyDown={this.closeDatePopupOnTab} selected={this.state.dateOfBirth} className="dob input-110 float-left rounded-lg" placeholderText="mm/dd/yyyy" showYearDropdown showMonthDropdown peekNextMonth dropdownMode="select" name="dob" id="dob" customInput={<MaskedInput type="text" mask={[/[01]/, /\d/, '/', /[0-3]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]} />} onChange={(e): void => this.handleChange(e)} popperPlacement="bottom" />
													</div>
													{this.state.isSearching ? (
														<Button id="searchRequestHistoryButton" type="button" color="btnSaveColor" className="btn save btnWidth" disabled>
															<Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
															Searching
														</Button>
													) : (
														<Button id="searchRequestHistoryButton" type="button" color="btnSaveColor" className={this.props.RequestHistoryStateManager.isDataLoading ? 'btn save btnWidth disabled' : 'btn save btnWidth'} onClick={(): Promise<void> => this.handleSearch()}>
															Search
														</Button>
													)}
												</div>
											</Col>
										</Row>
										<Row>
											<div>{this.showOrHideFilterResultsForPatientSearch()}</div>
											<div>{this.showOrHideFilterResultsForNpis()}</div>
											<div>{this.showOrHideFilterResultsForPayers()}</div>
											<div>{this.showOrHideFilterResultsForStatuses()}</div>
											<div>{this.showOrHideFilterResultsForEligibilityStatuses()}</div>
											<div>{this.showOrHideFilterResultsForTransactionDate()}</div>
											<div>{this.showOrHideClearAll()}</div>
										</Row>
									</form>
								</div>
								<div className="row-fluid form-header" id="filterHistoryHeader">
									<Button id="ExportResultstButton" type="button" className="btn save" color="btnSaveColor" style={{ width: 'fit-content' }} onClick={(): void => this.triggerEventBasedOnTransactionCount()} disabled={typeof this.props.RequestHistoryStateManager.selectedTransactionIds !== 'undefined' ? this.props.RequestHistoryStateManager.selectedTransactionIds.size === 0 : true}>
										Export Selected Requests
									</Button>
									<Button id="ViewResultstButton" type="button" className="btn save" color="btnSaveColor" style={{ marginLeft: '10px', width: 'fit-content' }} onClick={(): void => this.triggerEventBasedOnClickOfContinue()}>
										<span>View Reports </span>
										<span style={{ fontSize: '14px' }}>(Exported Requests)</span>
									</Button>
								</div>
								<div id="divForRequestHistoryTable">
									<PaginationProvider
										pagination={paginationFactory({
											custom: true,
											page: this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria.page,
											sizePerPage: this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria.sizePerPage,
											totalSize: this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridResults.total,
											showTotal: true,
											sizePerPageList: [
												{
													text: '10',
													value: 10,
												},
												{
													text: '25',
													value: 25,
												},
												{
													text: '50',
													value: 50,
												},
												{
													text: '100',
													value: 100,
												},
											],
											paginationTotalRenderer: (from: number, to: number, size: number) => (
												<span className="react-bootstrap-table-pagination-total">
													{' '}
													Showing {from} to {to} of {size} Results{' '}
												</span>
											),
										})}
									>
										{({ paginationProps, paginationTableProps }: any): React.ReactNode => {
											return (
												<div>
													<div id="tableStyle" style={{ marginBottom: this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridResults.total === 0 ? '30px' : '' }}>
														<span className={this.props.RequestHistoryStateManager.isDataLoading ? 'float-left disabled' : 'float-left'}>
															<SizePerPageDropdownStandalone {...paginationProps} />
														</span>
														<span id="page">
															<PaginationTotalStandalone {...paginationProps} />
														</span>
														<span className={this.props.RequestHistoryStateManager.isDataLoading ? 'float-right disabled' : 'float-right'}>
															<PaginationListStandalone {...paginationProps} />
														</span>
													</div>
													<Observer>
														{(): React.ReactElement => (
															<BootstrapTable
																loading={this.props.RequestHistoryStateManager.isDataLoading}
																keyField="id"
																classes="dataTable"
																bootstrap4
																hover
																condensed
																remote
																noDataIndication={(): React.ReactNode => <this.NoDataIndication />}
																onTableChange={(type: string, args: TableChangeState): void => this.handleTableChange(type, args)}
																overlay={overlayFactory({
																	spinner: true,
																	styles: {
																		spinner: (base: any) => ({
																			...base,
																			margin: `0px auto ${this.spinnerHeight}px auto !important`,
																			'& svg circle': {
																				stroke: 'rgba(122, 122, 122,1)',
																			},
																		}),
																		overlay: (base: any) => ({
																			...base,
																			background: 'rgba(243, 242, 239,0.5)',
																			'margin-top': `${this.isFirstTimeLoading ? 0 : 30}px !important`,
																			height: this.tableHeight + 'px !important',
																		}),
																	},
																})}
																data={this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridResults.items.slice()}
																defaultSorted={[
																	{
																		dataField: this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria.sortField,
																		order: this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridCriteria.sortOrder,
																	},
																]}
																filter={filterFactory()}
																{...paginationTableProps}
																columns={[
																	{
																		dataField: 'isSelected',
																		text: this.state.allOnPageSelected || this.props.RequestHistoryStateManager.coverageDiscoveryRequestHistoryGridResults.items.every(x => x.transactionStatusId === TransactionStatus.Pending) ? 'Clear all on this page' : 'Select all on this page',
																		sort: false,
																		headerStyle: (): Record<string, string> => {
																			return {
																				width: '13%',
																			}
																		},
																		formatter: (cell: JSX.Element, row: ICoverageDiscoveryRequestHistoryGridRow): JSX.Element => {
																			if (row.transactionStatusId !== TransactionStatus.Pending) {
																				return <Observer>{(): React.ReactElement => <Input type="checkbox" name="checkResponse[]" className="checkBoxForFacility" checked={row.isSelected} onChange={(e: { target: { checked: boolean } }): void => this.handleTransactionSelectChange(row, e.target.checked)} />}</Observer>
																			} else {
																				return <div></div>
																			}
																		},
																		headerEvents: {
																			onClick: this.handleTransactionSelectAll,
																		},
																	},
																	{
																		dataField: 'transactionStatusId',
																		text: 'Status',
																		sort: true,
																		headerStyle: (): Record<string, string> => {
																			return { width: '8%' }
																		},
																		formatter: (cell: JSX.Element, row: ICoverageDiscoveryRequestHistoryGridRow): JSX.Element => {
																			if (row.transactionStatusId === TransactionStatus.Pending) {
																				return (
																					<div>
																						<img alt="Pending" src="img/icon-drop-pending.png" title="Pending"></img>
																					</div>
																				)
																			} else if (row.transactionStatusId === TransactionStatus.Processing) {
																				return (
																					<div>
																						<img alt="Complete" src="img/icon-drop-processing.png" title="Processing"></img>
																					</div>
																				)
																			} else if (row.transactionStatusId === TransactionStatus.Complete) {
																				return (
																					<div>
																						<img alt="Complete" src="img/icon-drop-active.png" title="Complete"></img>
																					</div>
																				)
																			} else if (row.transactionStatusId === TransactionStatus.Error) {
																				return (
																					<div>
																						<img alt="Error" src="img/icon-drop-failed.png" title="Error"></img>
																					</div>
																				)
																			} else if (row.transactionStatusId === TransactionStatus.TimedOut) {
																				return (
																					<div>
																						<img alt="Timed Out" src="img/icon-drop-missing.png" title="Timed Out"></img>
																					</div>
																				)
																			} else {
																				return <div></div>
																			}
																		},
																	},
																	{
																		dataField: 'requestData',
																		text: 'Request',
																		sort: true,
																		headerStyle: (): Record<string, string> => {
																			return { width: '30%' }
																		},
																		formatter: (cell: JSX.Element, row: ICoverageDiscoveryRequestHistoryGridRow): JSX.Element => {
																			return (
																				<div id="requestDataForName">
																					<Row>
																						{' '}
																						{row.requestData.lastName},&nbsp;
																						{row.requestData.firstName}
																					</Row>
																					{row.requestData.dob !== null && (
																						<Row>
																							(<Moment format="MM/DD/YYYY">{row.requestData.dob.toString().substring(0, 10)}</Moment>)
																						</Row>
																					)}
																					<Row>
																						<Label>Payers:</Label>
																					</Row>
																					{row.transactionStatusId === TransactionStatus.Complete &&
																						typeof row.requestData.payerNames !== 'undefined' &&
																						row.requestData.payerNames !== null &&
																						row.requestData.payerNames.map((x, index) => (
																							<Row key={index} style={{ marginTop: '7px' }}>
																								{x}
																								{'\n'}
																							</Row>
																						))}
																					<Row>
																						<Label>Facility: </Label>
																					</Row>
																					<Row className="history-facility">
																						{row.requestData.facility} ({row.requestData.npi})
																					</Row>
																				</div>
																			)
																		},
																	},
																	{
																		dataField: 'requestor',
																		text: 'Owner',
																		sort: true,
																		headerStyle: (): Record<string, string> => {
																			return { width: '15%' }
																		},
																	},
																	{
																		dataField: 'requestDate',
																		text: 'Requested Date',
																		sort: true,
																		headerStyle: (): Record<string, string> => {
																			return { width: '10%' }
																		},
																		formatter: (cell: JSX.Element, row: ICoverageDiscoveryRequestHistoryGridRow): JSX.Element => {
																			return <Moment format="MM/DD/YYYY">{row.requestDate}</Moment>
																		},
																	},
																	{
																		dataField: 'reviewed',
																		text: 'Reviewed',
																		sort: true,
																		headerStyle: (): Record<string, string> => {
																			return {
																				width: '12%',
																			}
																		},
																		formatter: (cell: JSX.Element, row: ICoverageDiscoveryRequestHistoryGridRow): JSX.Element => {
																			if (row.transactionStatusId !== TransactionStatus.Pending) {
																				return (
																					<div id="reviewedData">
																						<Row style={{ marginLeft: '2px' }}>
																							<Observer>{(): React.ReactElement => <Input type="checkbox" name="checkReviewed[]" className="checkBoxForFacility" checked={row.reviewed} onChange={(e: { target: { checked: boolean } }): void => this.handleReviewedSelectChange(row, e.target.checked)} />}</Observer>
																						</Row>
																						{row.reviewed === true && (
																							<div>
																								<Row style={{ marginTop: '50px', marginLeft: '-60px' }}>
																									<Label>Reviewed By:</Label>
																								</Row>
																								<Row style={{ marginLeft: '-60px', marginTop: '0px' }}>{row.reviewedByUser}</Row>
																							</div>
																						)}
																						{row.reviewed === true && row.reviewedDate !== null && (
																							<div>
																								<Row style={{ marginTop: '30px', marginLeft: '-60px' }}>
																									<Label>Reviewed Date:</Label>
																								</Row>
																								<Row style={{ marginLeft: '-60px', marginTop: '0px' }}>
																									<Moment format="MM/DD/YYYY">{row.reviewedDate}</Moment>
																								</Row>
																							</div>
																						)}
																					</div>
																				)
																			} else {
																				return <div></div>
																			}
																		},
																	},
																	{
																		dataField: 'id',
																		text: '',
																		sort: false,
																		headerStyle: (): Record<string, string> => {
																			return { width: '9%' }
																		},
																		formatter: (cell: JSX.Element, row: ICoverageDiscoveryRequestHistoryGridRow): JSX.Element => {
																			return row.id !== null && typeof row.id !== 'undefined' ? (
																				<div>
																					<Link to={`/coverageDiscoveryResponse/${row.id}`}>DETAILS</Link>
																					<br />
																					{row.transactionStatusId !== TransactionStatus.Processing && <Link to={`/CoverageDiscoveryRequest/${row.id}`}>RERUN</Link>}
																				</div>
																			) : (
																				<div></div>
																			)
																		},
																	},
																]}
															/>
														)}
													</Observer>
													<br />
												</div>
											)
										}}
									</PaginationProvider>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		}
	}
	reloadPrevDetailsOnCancel(filteredResponseDetails: IFilteredResponseDetails | null): void {
		if (filteredResponseDetails) {
			// Transaction Status
			// Keep previous details
			// Remove current changes if found any
			filteredResponseDetails.transactionStatusIds &&
				this.props.RequestHistoryStateManager.availableTransactionStatuses.forEach(element => {
					if (filteredResponseDetails.transactionStatusIds) {
						this.handleStatusSelectedChange(
							element,
							filteredResponseDetails.transactionStatusIds.some(item => item === element.id),
						)
					}
				})

			// Eligibility Status
			// Keep previous details
			// Remove current changes if found any
			filteredResponseDetails.eligibilityStatusIds &&
				this.props.RequestHistoryStateManager.availableEligibilityStatuses.forEach(element => {
					if (filteredResponseDetails.eligibilityStatusIds) {
						this.handleEligibilityStatusSelectedChange(
							element,
							filteredResponseDetails.eligibilityStatusIds.some(item => item === element.id),
						)
					}
				})

			// NPI's
			// Keep previous details
			// Remove current changes if found any
			filteredResponseDetails.npiIds &&
				this.props.RequestHistoryStateManager.availableNpis.forEach(element => {
					if (filteredResponseDetails.npiIds) {
						this.handleNpiSelectedChange(
							element,
							filteredResponseDetails.npiIds.some(item => item === element.id),
						)
					}
				})

			// Payer's
			// Keep previous details
			// Remove current changes if found any
			filteredResponseDetails.payerIds &&
				this.props.RequestHistoryStateManager.availablePayers.forEach(element => {
					if (filteredResponseDetails.payerIds) {
						this.handlePayerSelectedChange(
							element,
							filteredResponseDetails.payerIds.some(item => item === element.id),
						)
					}
				})

			this.setState({
				checkedRunDate: filteredResponseDetails.runDateSelected,
				selectedRunDateRangeId: filteredResponseDetails.runDateRangeId,
				transactionDate: filteredResponseDetails.runDate,
			})
			return
		}
		return
	}
	loadCurrentValues(): void {
		const selectedTransactionStatuses: number[] | undefined = this.props.RequestHistoryStateManager.availableTransactionStatuses.filter(item => item.isSelected).map(item => item.id)
		const selectedEligibilityStatuses: number[] | undefined = this.props.RequestHistoryStateManager.availableEligibilityStatuses.filter(item => item.isSelected).map(item => item.id)
		const selectedNpis: number[] | undefined = this.props.RequestHistoryStateManager.availableNpis.filter(item => item.isSelected).map(item => item.id)
		const selectedPayers: number[] | undefined = this.props.RequestHistoryStateManager.availablePayers.filter(item => item.isSelected).map(item => item.id)
		const transactionDate = this.state.checkedRunDate ? this.state.transactionDate : new Date()
		this.setState({
			selectedRunDateRangeId: this.state.checkedRunDate ? this.state.selectedRunDateRangeId : 0,
			filteredResponseDetails: {
				transactionStatusIds: selectedTransactionStatuses,
				eligibilityStatusIds: selectedEligibilityStatuses,
				npiIds: selectedNpis,
				payerIds: selectedPayers,
				runDateSelected: this.state.checkedRunDate,
				runDateRangeId: this.state.selectedRunDateRangeId,
				runDate: this.state.transactionDate,
			},
			// Clear run date range and run date values from the form if run date checkbox is not selected
			transactionDate: transactionDate,
			searchedTransactionDate: transactionDate,
		})
		return
	}
}
export const RequestHistoryConnected = (): any => {
	const RequestHistoryStateManager = container.get<IRequestHistoryStateManager>('IRequestHistoryStateManager')
	const userSessionStateManager = container.get<IUserSessionStateManager>('IUserSessionStateManager')
	return <Route path="/RequestHistory/:batchRunId?" render={(props): React.ReactElement => <RequestHistory {...props} batchRunId={props.match.params.batchRunId} RequestHistoryStateManager={RequestHistoryStateManager} usersessionStateManager={userSessionStateManager} />} />
}
